module.exports = __webpack_public_path__ + "skins/Internet-Archive-f86f47ed539e393678f805fe776e4d30.wsz";


//////////////////
// WEBPACK FOOTER
// ./skins/Internet-Archive.wsz
// module id = 139
// module chunks = 5